module.exports = {"TXTCLI_Free_Spins":{"id":"TXTCLI_Free_Spins","defaultMessage":"Freispiele","track":"Free Spins"}}